export enum storageKeys {
  activeSubAccount = "active_sub-account",
  activeTerminal = "active_terminal"
}